import { action, observable, makeObservable } from 'mobx';
import { persist } from 'mobx-persist';
import { getDeviceType } from 'src/utils/helpers';

export class SidebarStore {
  constructor() {
    makeObservable(this);
  }

  public get persist() {
    return true;
  }
  @persist @observable public isOpen: boolean = getDeviceType() === 'desktop';

  // actions

  @action public menuSwitch = () => {
    this.isOpen = !this.isOpen;
  };

  @action public menuClose = () => {
    this.isOpen = false;
  };
}

const sidebarStore = new SidebarStore();

export { sidebarStore };
